// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__DhUh2","topBottomGutter":"Layout_topBottomGutter__I91rc"};